// Todo: Incrementally add Action descriminate types when they'll be needed. e.g. HubSection
import { SortDirection } from 'pages/_AdminAuthoringPages/_components/HubSectionForm';
import { Hubs, HubResourceId, OrgTypeFiltering } from 'utils/gloo-types';
import { HubAuthoringFormErrors, SectionContentType } from './types';

export enum SplitSectionSide {
  LEFT = 'a',
  RIGHT = 'b',
}

export enum ActionType {
  setHubId,
  setIsLoading,
  hydrateStore,
  toggleIsEditMode,
  setIsHeaderMinimized,
  setIsModalShowing,
  setDisplayedInDiscover,
  setFeaturedPriority,
  setAuthor,
  setTitle,
  setShortDescription,
  setLongDescription,
  setBackgroundColor,
  setTitleColor,
  setDescriptionColor,
  setLogoImageUrl,
  setThumbnailImageUrl,
  setHeaderImageUrl,
  setTags,
  setVisibleInDiscover,
  setOrgTypeFiltering,
  addSection,
  orderSections,
  deleteSection,
  addErrors,
  removeErrors,
  // section actions
  setSectionTitle,
  setSectionDescription,
  setSectionTitleColor,
  setSectionDescriptionColor,
  setSectionBackgroundColor,
  setSectionBackgroundImage,
  setSectionText,
  setSectionTextColor,
  setSectionImageUrl,
  setSectionLinkUrl,
  addSectionResource,
  orderSectionResourceIds,
  deleteSectionResourceId,
  // split section actions
  setSplitSectionDestinationLinkUrl,
  setSplitSectionImageUrl,
  setSplitSectionText,
  setSplitSectionTextColor,
  setArchivedAt,
}

export type Action =
  | {
      type: ActionType.removeErrors;
    }
  | {
      type: ActionType.addErrors;
      payload: HubAuthoringFormErrors[];
    }
  | {
      type: ActionType.hydrateStore;
      payload: Hubs;
    }
  | {
      type: ActionType.setIsLoading;
      isLoading: boolean;
    }
  | {
      type: ActionType.toggleIsEditMode;
    }
  | {
      type: ActionType.setIsHeaderMinimized;
    }
  | {
      type: ActionType.setTitleColor;
      payload: string;
    }
  | {
      type: ActionType.setDescriptionColor;
      payload: string;
    }
  | {
      type: ActionType.setBackgroundColor;
      payload: string;
    }
  | {
      type: ActionType.setTitle;
      payload: string;
    }
  | {
      type: ActionType.addSection;
      section: SectionContentType;
    }
  | {
      type: ActionType.setShortDescription;
      payload: string;
    }
  | {
      type: ActionType.setAuthor;
      payload: string;
    }
  | {
      type: ActionType.setLongDescription;
      payload: string;
    }
  | {
      type: ActionType.setVisibleInDiscover;
      visibleInDiscover: boolean;
    }
  | {
      type: ActionType.setOrgTypeFiltering;
      orgTypeFiltering: OrgTypeFiltering;
    }
  | {
      type: ActionType.setHubId;
      hubId: string | null;
    }
  | {
      type: ActionType.orderSections;
      payload: { index: number; isLast: boolean; sortDirection: SortDirection };
    }
  | {
      type: ActionType.setThumbnailImageUrl;
      payload: string;
    }
  | {
      type: ActionType.setLogoImageUrl;
      payload: string;
    }
  | {
      type: ActionType.setHeaderImageUrl;
      payload: string;
    }
  | {
      type: ActionType.addSection;
      section: SectionContentType;
    }
  | {
      type: ActionType.addSectionResource;
      payload: { index: number; hubResourceId: HubResourceId };
    }
  | {
      type: ActionType.deleteSection;
      payload: { index: number };
    }
  | {
      type: ActionType.setSectionTitle;
      payload: { index: number; title: string };
    }
  | {
      type: ActionType.setSectionDescription;
      payload: { index: number; description: string };
    }
  | {
      type: ActionType.setSectionTitleColor;
      payload: { index: number; titleColor: string };
    }
  | {
      type: ActionType.setSectionDescriptionColor;
      payload: { index: number; descriptionColor: string };
    }
  | {
      type: ActionType.setSectionBackgroundColor;
      payload: { index: number; backgroundColor: string };
    }
  | {
      type: ActionType.setSectionBackgroundImage;
      payload: { index: number; backgroundImage: string };
    }
  | {
      type: ActionType.setSectionText;
      payload: { index: number; text: string };
    }
  | {
      type: ActionType.setSectionTextColor;
      payload: { index: number; textColor: string };
    }
  | {
      type: ActionType.setSectionImageUrl;
      payload: { index: number; imageUrl: string };
    }
  | {
      type: ActionType.setSectionLinkUrl;
      payload: { index: number; linkUrl: string };
    }
  | {
      type: ActionType.setSplitSectionText;
      payload: { index: number; text: string; side: SplitSectionSide };
    }
  | {
      type: ActionType.setSplitSectionDestinationLinkUrl;
      payload: { index: number; linkUrl: string; side: SplitSectionSide };
    }
  | {
      type: ActionType.setSplitSectionImageUrl;
      payload: { index: number; imageUrl: string; side: SplitSectionSide };
    }
  | {
      type: ActionType.setSplitSectionTextColor;
      payload: { index: number; textColor: string; side: SplitSectionSide };
    }
  | {
      type: ActionType.orderSectionResourceIds;
      payload: { sectionIndex: number; resourceIdIndex: number; isLast: boolean; sortDirection: SortDirection };
    }
  | {
      type: ActionType.deleteSectionResourceId;
      payload: { sectionIndex: number; resourceIdIndex: number };
    }
  | {
      type: ActionType.setArchivedAt;
      archivedAt?: Date;
    };
